import { CrossClientQueryAtomicClause, CrossClientQueryLogicalQuestionNNFDecomposition } from '../../../models/CrossClient'
import React from 'react'

export interface CrossClientClausesProps {
  atomicClauses: CrossClientQueryAtomicClause[]
  nnfDecomposition?: CrossClientQueryLogicalQuestionNNFDecomposition
}

const getDescriptionForClause = (clause: CrossClientQueryAtomicClause, nnfDecomposition?: CrossClientQueryLogicalQuestionNNFDecomposition) => {
  if (!nnfDecomposition || !nnfDecomposition.negatedClauses[clause.variable]) {
    return clause.description
  }
  const nnfClause = nnfDecomposition.atomicClauses.find((nnfClause) => nnfClause.variable === nnfDecomposition.negatedClauses[clause.variable])
  return nnfClause ? nnfClause.description : clause.description
}

export const CrossClientClauses: React.FC<CrossClientClausesProps> = ({ atomicClauses, nnfDecomposition }) => {
  return (
    <div className='d-flex flex-column gap-3'>
      {atomicClauses.map((clause, index) => (
        <div key={index} className='d-flex gap-2 align-items-center'>
          <i className='bi bi-x-diamond-fill zocks-text-info fs-6' />
          <div className='paragraph-small medium'>{getDescriptionForClause(clause, nnfDecomposition)}</div>
        </div>
      ))}
    </div>
  )
}
